import api, { empApi } from "@/lib/api";
import InventoryPage from "@/pages/InventoryPage";
import CheckoutsPage from "@/pages/CheckoutsPage";

// Thin wrappers so we can mount the shared pages with the right axios instance.
export function AdminInventory() { return <InventoryPage mode="admin" apiClient={api} />; }
export function EmployeeInventory() { return <InventoryPage mode="employee" apiClient={empApi} />; }
export function AdminCheckouts() { return <CheckoutsPage mode="admin" apiClient={api} />; }
export function EmployeeCheckouts() { return <CheckoutsPage mode="employee" apiClient={empApi} />; }
